<template>
  <div class="list row">
    <div class="col-md-12 hgap"></div>
    <div class="col-md-12">
      <h4><font-awesome-icon icon="list-alt" /> Purchases List</h4>
      <table class="gridview">
        <tr>
            <th>S/N</th><th>NetworkID</th><th>Surname</th><th>First Name</th><th>Product</th><th>Quantity</th><th>Total Pv</th><th>Date</th>
        </tr>
        <tr class="" :class="{ active: index == currentIndex }" v-for="(sale, index) in sales" :key="index">
            <td>{{ index+1 }}</td><td>{{ sale.network_member_id }}</td><td>{{ sale.surname }}</td><td>{{ sale.first_name }}</td>
            <td>{{ sale.name }}</td><td>{{ sale.quantity }}</td><td>{{ sale.total_pv }}</td><td>{{ sale.sold_date | moment("DD/MM/YYYY") }}</td>
        </tr>
      </table>
      <div class="col-md-12 hgap"></div>
      <div v-if="loading" class="justify-content-center">
        <font-awesome-icon icon="spinner" /> <span>Loading...please wait</span>
      </div>
      <table class="table table-borderless">
        <tr>
          <td>
            <div class="d-flex justify-content-center">
              Items per Page:
              <select v-model="pageSize" @change="handlePageSizeChange($event)">
                <option v-for="size in pageSizes" :key="size" :value="size">
                  {{ size }}
                </option>
              </select>
            </div>
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <b-pagination v-model="page" :total-rows="count" :per-page="pageSize" prev-text="Prev" next-text="Next" @change="handlePageChange"></b-pagination>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import SaleService from "../services/sale.service";

export default {
  name: "sales-list",
  data() {
    return {
      sales: [],
      currentMemberId: 0,
      currentIndex: 0,
      page: 1,
      count: 0,
      pageSize: 25,
      pageSizes: [25, 50, 75, 100],
      totalPages: 0,
      loading: false
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    } 
  },
  methods: {
    retrieveSalesByMemberId(memberId) {
      this.loading = true;
      if (this.page) {
        this.page = this.page - 1;
      }
      SaleService.getTotalSalesByMemberId(memberId)
        .then(response => {
          this.count = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });

      SaleService.getSalesByMemberIdPageable(memberId, this.page, this.pageSize)
        .then(response => {
          this.sales = response.data;
          //console.log(response.data);
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
        });
      
    },

    handlePageChange(value) {
      this.page = value;
      this.retrieveSalesByMemberId(this.currentMemberId);
    },

    handlePageSizeChange(event) {
      this.pageSize = event.target.value;
      this.page = 1;
      this.retrieveSalesByMemberId(this.currentMemberId);
    },

  },
  mounted() {
    this.currentMemberId = this.currentUser.username;  
    this.retrieveSalesByMemberId(this.currentUser.username);
  }
};
</script>

<style>
.list {
  text-align: left;
  max-width: 100%;
  margin: auto;
  margin-top: 3.2em;
}
.paginate{
  margin-top: 1.7em;
}
.hgap{
  clear: both;
  margin-top: 1.1em;
}

.gridview
{
    border-collapse: collapse;
    margin: 0px 10px 10px 0;
    /*box-shadow: 3px 3px 4px #bbb;*/
    width: 100%;
    max-width: 100%;    
}

.gridview, .gridview td,  .gridview th
{
    border:  1px solid #cccccc;
}

.gridview th
{
    text-align: left;
    /*font-size: 1.2em;*/
    font-weight: normal;
    color: #F9F9F9;    
    background: #232324;
}

.gridview th a, .gridview th a:link, .gridview th a:visited, .gridview th a:active
{
    color: #fff;
    text-decoration: none;
}

.gridview th a:hover
{
    text-decoration: underline;
}

.gridview tr
{
    background: #fff;
}

.gridview tr:nth-child(odd) 
{
    background-color: #fff;
}
.gridview tr:nth-child(even) 
{
    background-color: #fff;
}

.gridview td 
{
    font-weight: normal;    
    text-align: left;
    vertical-align: top;
}

.gridview td, table th
{
    padding: 5px 8px;
}

.gridview tfoot td
{
    background-color: #fff;
}

.gridview tfoot td .page
{
    color: #000000;
    font-weight: bold;
}

.gridview tr.subfoot, .gridview tr.subfoot td
{
    background-color: #1E90FF;
}

.gridview tr:hover td, .gridview tbody tr:hover td
{
    background-color: #1E90FF;
    color: #fff;
}

.gridview .selected, .gridview tr td .selected
{
    background-color: #1E90FF;
    color: #fff;
}

.gridview tr.active td, .gridview tbody tr.active td
{
    background-color: #1E90FF;
    color: #fff;
}
</style>